import { ProductType } from 'features/searchResultsFacets';
import HomesTab from '../components/resultTabs/homesTab';
import CommunitiesTab from '../components/resultTabs/communitiesTab';
import BuildersTab from '../components/resultTabs/buildersTab';
import BuildOnYourLotLocationsTab  from '../components/resultTabs/buildOnYourLotLocationsTab';
import CustomHomesTab from '../components/resultTabs/customHomesTab';
import ManufacturedHomesTab from '../components/resultTabs/manufacturedHomesTab';
import ManufacturedLocationsTab from '../components/resultTabs/manufacturedLocationsTab';

// These lists are the tabs that will be shown in order.
const defaultTabs = [new HomesTab(), new CommunitiesTab(), new BuildersTab()];
const customAndBuildOnYourLotTabs = [new CustomHomesTab(), new BuildOnYourLotLocationsTab()];
const ManufacturedTabs = [new ManufacturedHomesTab(), new ManufacturedLocationsTab()];

const resultTabConfigurationMapper = new Map();

resultTabConfigurationMapper.set(ProductType.AllProducts.toString(), defaultTabs);
resultTabConfigurationMapper.set(ProductType.Communities.toString(), defaultTabs);
resultTabConfigurationMapper.set(ProductType.Homes.toString(), defaultTabs);
resultTabConfigurationMapper.set(ProductType.Custom.toString(), customAndBuildOnYourLotTabs);
resultTabConfigurationMapper.set(ProductType.BuildOnYourLot.toString(), customAndBuildOnYourLotTabs);
resultTabConfigurationMapper.set(ProductType.Manufactured.toString(), ManufacturedTabs);

/**
 * getResultTabConfiguration: Gets configuration for the tabs to be used according to
 * the product type.
 * @param {string} productTypeName The name of the product type.
 * @returns The name of the result tab group according to the product type.
 */
function getResultTabConfiguration(productTypeName) {
  const resultsTabConfiguration = resultTabConfigurationMapper.get(productTypeName);

  return resultsTabConfiguration ?? [];
}

export default getResultTabConfiguration;